import { InputElementProps, InputLeftElement } from '@chakra-ui/react';
import React from 'react';

export const CmInputLeftElement: React.FC<InputElementProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <InputLeftElement {...{ ...rest }}>{children}</InputLeftElement>;
};
